import type { FC } from 'react'

import { css } from '@emotion/react'
import { VscDebugRestart } from 'react-icons/vsc'

import type { GameOver } from '@/App'

export const GameOverScreen: FC<{
  gameOver: GameOver | null
  onReset: () => void
}> = ({ gameOver, onReset }) => {
  return (
    <>
      {gameOver && (
        <div
          css={css`
            position: absolute;
            width: 50vw;
            min-width: 300px;
            height: 300px;
            background: rgba(30, 40, 54, 0.95);
            backdrop-filter: blur(15px);
            border: 2px solid #D72A29;
            border-radius: 15px;
            display: flex;
            gap: 1rem;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            top: 50%;
            left: 50%;
            z-index: 100;
            transform: translate(-50%, -50%);
            box-shadow: 0 10px 30px rgba(215, 42, 41, 0.3);
            h1 {
              color: #D72A29;
              font-size: 2.5rem;
              font-weight: bold;
              text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
              margin-bottom: 20px;
            }
            button {
              background: linear-gradient(135deg, #D72A29, #931A1D);
              color: white;
              font-size: 2rem;
              border: none;
              border-radius: 10px;
              padding: 15px 25px;
              cursor: pointer;
              transition: all 0.3s ease;
              box-shadow: 0 4px 15px rgba(215, 42, 41, 0.4);
              
              &:hover {
                transform: translateY(-2px);
                box-shadow: 0 6px 20px rgba(215, 42, 41, 0.6);
              }
            }
          `}
        >
          <h1>
            {gameOver.type === `checkmate`
              ? `Checkmate! ${gameOver.winner} wins!`
              : `Stalemate!`}
          </h1>
          <button onClick={onReset}>
            <VscDebugRestart />
          </button>
        </div>
      )}
    </>
  )
}
